import { AnySchema, SchemaComponent } from "./types";

export const createResolver =
  <T extends Record<string, SchemaComponent<AnySchema>>>(schemaComponents: T) =>
  (schemaType: keyof T): SchemaComponent =>
    schemaComponents[schemaType] as SchemaComponent;
